import React, { useState, useEffect } from 'react';
import axiosAPIinstance from '../../config/axiosAPIinstance';
import { useNavigate, useLocation } from 'react-router-dom';  // Use useNavigate instead of useHistory
import {
    TextField,
    Button,
    Checkbox,
    FormControlLabel,
    Select,
    MenuItem,
    Box,
    Typography,
    Container,
    Paper,
    Grid,
    InputLabel,
    CircularProgress
} from '@mui/material';
import BackButton from '../BackButton';

const CategoryForm = ({ onSuccess }) => {

    const location = useLocation();
    const { categoryId } = location.state || {};
    const navigate = useNavigate();
    const [category, setCategory] = useState({
        name: '',
        imageUrl: '',
        description: '',
        parentCategoryId: '',
        featured: false,
        priority: 0,
        status: 'ACTIVE',
    });
    const [categories, setCategories] = useState([]);
    const [imagePreview, setImagePreview] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (categoryId) fetchCategory(categoryId);
        fetchParentCategories();
    }, [categoryId]);

    const fetchParentCategories = async () => {
        try {
            const { data } = await axiosAPIinstance.get('/categories');
            setCategories(data);
        } catch (error) {
            console.error('Error fetching parent categories:', error);
        }
    };

    const fetchCategory = async (id) => {
        try {
            const { data } = await axiosAPIinstance.get(`/categories/${id}`);
            setCategory(data);
            if (data.imageUrl) setImagePreview(data.imageUrl);
        } catch (error) {
            console.error('Error fetching category:', error);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setCategory((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append("name", category.name);
            formData.append("description", category.description || "");
            formData.append("priority", category.priority || 0);
            formData.append("status", category.status || "");
            formData.append("featured", category.featured || "false");
            formData.append("parentCategoryId", category.parentCategoryId || "");
            if (category.imageFile) {
                formData.append("image", category.imageFile);
            }
            const method = categoryId ? 'put' : 'post';
            const url = categoryId ? `/categories/${categoryId}` : '/categories/createCategory';

            const response = await axiosAPIinstance({
                method,
                url,
                data: formData,
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            console.log("Category Created/Updated:", response.data);
            navigate('/categorysList');
            alert('Category Created/Updated successfully!');
        } catch (error) {
            console.error("Error creating/updating category:", error.response ? error.response.data : error.message);
        }
        setLoading(false);
    };

    const handleDelete = async () => {
        if (!categoryId) return;

        const confirmDelete = window.confirm("Are you sure you want to delete this category?");
        if (!confirmDelete) return;  // Stop execution if user cancels

        try {
            await axiosAPIinstance.delete(`/categories/${categoryId}`);
            alert('Category Deleted successfully!');
            navigate('/categorysList');  // Ensure navigation after deletion
        } catch (error) {
            console.error('Error deleting category:', error);
            alert('Failed to delete category!');
        }
    };


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImagePreview(URL.createObjectURL(file));
            setCategory((prev) => ({ ...prev, imageFile: file }));
        }
    };

    return (
        <>
            <Container maxWidth="sm" sx={{ mt: 4 }}>
                <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
                    <Typography variant="h4" align="center" gutterBottom>
                        {categoryId ? 'Update Category' : 'Create New Category'}
                    </Typography>

                    {imagePreview && (
                        <Box display="flex" justifyContent="center" mb={3}>
                            <img
                                src={imagePreview}
                                alt="Preview"
                                style={{
                                    width: '150px',
                                    height: '150px',
                                    borderRadius: '50%',
                                    border: '5px solid lightgray',
                                }}
                            />
                        </Box>
                    )}

                    <Box component="form" onSubmit={handleSubmit} noValidate>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Button variant="contained" component="label" fullWidth>
                                    Upload Image
                                    <input type="file" hidden accept="image/*" onChange={handleImageChange} />
                                </Button>
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    required
                                    label="Category Name"
                                    name="name"
                                    value={category.name}
                                    onChange={handleChange}
                                    variant="outlined"
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Description"
                                    name="description"
                                    value={category.description}
                                    onChange={handleChange}
                                    multiline
                                    rows={3}
                                    variant="outlined"
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <InputLabel>Parent Category</InputLabel>
                                <Select
                                    fullWidth
                                    name="parentCategoryId"
                                    value={category.parentCategoryId || ''}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="">None</MenuItem>
                                    {categories.filter(cat => cat.id !== categoryId).map((cat) => (
                                        <MenuItem key={cat.id} value={cat.id}>
                                            {cat.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Priority"
                                    name="priority"
                                    type="number"
                                    value={category.priority}
                                    onChange={handleChange}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="featured"
                                            checked={category.featured}
                                            onChange={handleChange}
                                        />
                                    }
                                    label="Featured Category"
                                />
                            </Grid>

                            {/* <Grid item xs={12}>
                                <Box mt={3} display="flex" justifyContent="space-between">
                                    {loadin}
                                    <Button type="submit" variant="contained" color="primary">
                                        {categoryId ? 'Update' : 'Create'}
                                    </Button>
                                    {categoryId && (
                                        <Button variant="outlined" color="error" onClick={handleDelete}>
                                            Delete
                                        </Button>
                                    )}
                                </Box>
                            </Grid> */}
                            <Grid item xs={12}>
                                <Box mt={3} display="flex" alignItems="center" justifyContent="space-between">
                                    {/* Loading Indicator */}
                                    {loading ? (
                                        <Box display="flex" alignItems="center" gap={1}>
                                            <CircularProgress size={24} color="primary" />
                                            <span>Processing...</span>
                                        </Box>
                                    ) : (
                                        <Box />
                                    )}
                                    {/* Submit Button */}
                                    <Button type="submit" variant="contained" color="primary" disabled={loading}>
                                        {categoryId ? 'Update' : 'Create'}
                                    </Button>
                                    {/* Delete Button (if editing) */}
                                    {categoryId && (
                                        <Button variant="outlined" color="error" onClick={handleDelete} disabled={loading}>
                                            Delete
                                        </Button>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
            </Container>

            <div className='divFlexSpan'>
                <BackButton />
            </div>
        </>
    );
};

export default CategoryForm;
